import { BidReportAllAnswers } from "lib/generated/app-service-gql/graphql";

// TODO: Long-term plan is to remove this public API and implement graphql federation instead

/**
 * Fetches bid qualification content for a non-logged in user
 * @return
 */
export async function getBidQualContentForExternalUser(
  bidReportId: string,
  urlShareSignature: string | null,
): Promise<BidReportAllAnswers | undefined> {
  if (!urlShareSignature) {
    return;
  }
  try {
    const response = await fetch(`${window.app_service_url}/bid-report-api/getAnswers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ bidReportId, urlShareSignature }),
    });

    if (!response.ok) {
      console.error(`Error: ${response.status} - ${response.statusText}`);
    }

    return (await response.json()) as BidReportAllAnswers;
  } catch (error) {
    console.error("Failed to fetch answers: ", error);
    throw error;
  }
}
